<page-container [hasFilter]="false" [listName]="''" [hasGrid]="false">
  <form
    autocomplete="off"
    class="form-sticky-title px-3 pt-2"
  >
    <div class="card flex-auto">
      <div class="col-sm-12 mb-2">
        <h4 class="title m-0">{{ 'Upload receipt' | translate }}</h4>
      </div>
      <mat-divider class="-mx-6 text-border"></mat-divider>
      <div class="flex flex-col sm:flex-row sm:gap-4 py-4">
        <div class="d-flex gap-2 flex-column images" *ngIf="!loading; else loader">
          <div class="img mb-3">
            <img
              class="img-placeholder cursor-pointer"
              *ngIf="avatarSrc"
              (click)="openImageViewer(avatarSrc)"
              src="{{ avatarSrc }}"
              alt="kse"
            />
            <mat-icon
              *ngIf="avatarSrc"
              (click)="removeFile()"
              class="remove cursor-pointer"
              svgIcon="mat:close"
            ></mat-icon>
          </div>
          <mat-radio-group
            [(ngModel)]="uploadOption"
            [ngModelOptions]="{ standalone: true }"
            color="primary"
            aria-label="Select an option"
            *ngIf="!avatarSrc"
          >
            <mat-radio-button value="1">{{
              'Upload new receipt' | translate
              }}</mat-radio-button>
            <mat-radio-button value="2">{{
              'Choose from uploaded receipts' | translate
              }}</mat-radio-button>
          </mat-radio-group>
          <div *ngIf="uploadOption === '2'" class="d-flex gap-3 mt-2">
            <button
              mat-raised-button
              color="primary"
              (click)="openLastReceiptsDialog()"
              type="button"
            >
              {{ 'Choose from last files' | translate }}
            </button>
            <a
              *ngIf="selectedImage"
              href="{{ selectedImage.filePathThumbnail }}"
              target="_blank"
              class="selectedImageName"
            >
              {{ selectedImage?.documentName }}
            </a>
          </div>
          <div
            (click)="uploadRec.click()"
            *ngIf="!avatarSrc && uploadOption === '1'"
            class="col-sm-8 empty-img d-flex justify-content-center align-items-center flex-column"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
            >
              <path
                d="M38.4814 35.6378H5.51821C5.16825 35.6378 4.88379 35.3533 4.88379 35.0034V13.296C4.88379 12.9461 5.16825 12.6616 5.51821 12.6616H38.4814C38.8313 12.6616 39.1158 12.9461 39.1158 13.296V35.0034C39.1158 35.3544 38.8313 35.6378 38.4814 35.6378ZM6.15263 34.369H37.847V13.9305H6.15263V34.369Z"
                fill="#475569"
              />
              <path
                d="M21.9997 32.9813C17.13 32.9813 13.168 29.0193 13.168 24.1496C13.168 19.2799 17.13 15.3179 21.9997 15.3179C26.8694 15.3179 30.8314 19.2799 30.8314 24.1496C30.8314 29.0193 26.8694 32.9813 21.9997 32.9813ZM21.9997 16.5867C17.8299 16.5867 14.4368 19.9798 14.4368 24.1496C14.4368 28.3194 17.8289 31.7125 21.9997 31.7125C26.1705 31.7125 29.5626 28.3204 29.5626 24.1496C29.5626 19.9798 26.1695 16.5867 21.9997 16.5867Z"
                fill="#DABC7E"
              />
              <path
                d="M21.9997 30.3597C18.5759 30.3597 15.7896 27.5744 15.7896 24.1496C15.7896 20.7248 18.5749 17.9395 21.9997 17.9395C25.4245 17.9395 28.2098 20.7248 28.2098 24.1496C28.2098 27.5744 25.4235 30.3597 21.9997 30.3597ZM21.9997 19.2083C19.2748 19.2083 17.0584 21.4247 17.0584 24.1496C17.0584 26.8745 19.2748 29.0909 21.9997 29.0909C24.7246 29.0909 26.941 26.8745 26.941 24.1496C26.941 21.4257 24.7246 19.2083 21.9997 19.2083Z"
                fill="#DABC7E"
              />
              <path
                d="M34.2349 19.069C32.9599 19.069 31.9224 18.0314 31.9224 16.7564C31.9224 15.4814 32.9599 14.4438 34.2349 14.4438C35.5099 14.4438 36.5475 15.4814 36.5475 16.7564C36.5475 18.0314 35.5099 19.069 34.2349 19.069ZM34.2349 15.7127C33.6599 15.7127 33.1912 16.1803 33.1912 16.7564C33.1912 17.3325 33.6599 17.8001 34.2349 17.8001C34.81 17.8001 35.2786 17.3325 35.2786 16.7564C35.2786 16.1803 34.81 15.7127 34.2349 15.7127Z"
                fill="#DABC7E"
              />
              <path
                d="M12.4048 13.9304H8.96157C8.61161 13.9304 8.32715 13.6459 8.32715 13.296V10.569C8.32715 10.219 8.61161 9.93457 8.96157 9.93457H12.4048C12.7548 9.93457 13.0392 10.219 13.0392 10.569V13.296C13.0392 13.6459 12.7548 13.9304 12.4048 13.9304ZM9.59599 12.6615H11.7704V11.2034H9.59599V12.6615Z"
                fill="#475569"
              />
              <path
                d="M28.257 13.9304H15.7426C15.5328 13.9304 15.3374 13.827 15.2187 13.6541C15.1 13.4812 15.0754 13.2612 15.1511 13.0657L16.8293 8.766C16.9244 8.52247 17.1588 8.36182 17.4207 8.36182H26.5789C26.8398 8.36182 27.0751 8.52247 27.1703 8.766L28.8484 13.0657C28.9242 13.2612 28.8996 13.4812 28.7809 13.6541C28.6622 13.827 28.4668 13.9304 28.257 13.9304ZM16.6717 12.6615H27.3279L26.145 9.63065H17.8535L16.6717 12.6615Z"
                fill="#475569"
              />
            </svg>
            <span>{{ 'Upload receipt' | translate }}</span>
          </div>
          <input
            #uploadRec
            style="display: none"
            accept="image/png, .jpeg, .jpg, image/bmp"
            type="file"
            (change)="addFile($event)"
          />
          <div>{{ avatarRequirementsError }}</div>
        </div>
        <ng-template #loader>
          <p class="placeholder-wave img-placeholder">
            <span class="placeholder"></span>
          </p>
        </ng-template>
      </div>
    </div>

    <button
      class="my-2"
      (click)="submit()"
      mat-flat-button
      type="button"
      [disabled]="(!avatarSrc && !selectedImage )|| loading"
      color="primary"
    >
            <span class="mat-button-wrapper">{{
              'Update' | translate
              }}</span>
    </button>
  </form>
</page-container>
